const APP_PACKAGES_CONSTANTS = {
  CREATE_PACKAGE: 'CreatePackage',
  PACKAGES: 'Packages',
  VIEW_PACKAGE: 'ViewPackage/:packageUID',
  CREATE_PACKAGE_GROUP: 'CreatePackageGroup',
  PACKAGE_GROUPS: 'PackageGroups',
  VIEW_PACKAGE_GROUP: 'ViewPackageGroup/:packageGroupUID',
};
export default APP_PACKAGES_CONSTANTS;
